import React from 'react';
import { Typography, IconButton, Link } from '@material-ui/core';
import { RakutenIcon } from '@next-common/material-ui-icons';
import { useStyles } from './BoxLink.style';
import { colorPalette } from '../../colorPalette';
export const BoxLink = (props) => {
    const { label, url, newWindow, variant, iconColor, icon } = props;
    //const Icon: any = Icons[icon];
    let target = undefined;
    if (newWindow) {
        target = '_blank';
    }
    const classes = useStyles(props);
    return (React.createElement(Link, { href: url, target: target, underline: "none" },
        React.createElement("div", { className: `${classes.container} ${variant === 'shadowed' ? classes.shadowed : classes.default}`, "data-qa": "box-link" },
            React.createElement(Typography, null, label),
            React.createElement(IconButton, { className: classes.button },
                React.createElement(RakutenIcon, { icon: icon, fontSize: "small", htmlColor: iconColor && colorPalette[iconColor] }),
                ' '))));
};
